import {
  BeneficiaryDetails,
  BeneficiaryEntityType,
  BeneficiaryTransferDestination,
  USDBeneficiaryOptions,
} from 'types/beneficiaries'
import { SourceWallet } from 'types/move/move'
import { PayoutInstructionTypes, PayoutRequest } from 'types/unifiedPayouts/unifiedPayouts'
import { WalletPayReceiverDetails, WalletsPayRequest } from 'types/wallets'
import { FiatSendFormData } from './form/fiatSendFormSchema'

export const getUnifiedPayoutRequest = (
  formValues: FiatSendFormData,
  selectedWallet: SourceWallet,
  fiatBeneficiary: BeneficiaryDetails
): PayoutRequest => {
  return {
    walletId: selectedWallet?.walletId,
    amount: {
      value: formValues?.amount,
      currency: selectedWallet?.currency,
    },
    ...(formValues?.customerFee && {
      customerFee: {
        value: formValues?.customerFee,
        currency: selectedWallet?.currency,
      },
    }),
    paymentReference: formValues?.paymentReference,
    instruction: {
      type: PayoutInstructionTypes?.FIAT,
      beneficiary: {
        reference: fiatBeneficiary?.reference,
      },
      ...(formValues?.achSameDay && {
        paymentMethod: USDBeneficiaryOptions.ACH_SAME_DAY,
      }),
    },
  }
}

export const getLegacyPayoutRequest = (
  formValues: FiatSendFormData,
  selectedFiatBeneficiary: BeneficiaryDetails,
  twoFactorEnabled: boolean
): WalletsPayRequest => {
  const {
    fiat,
    address,
    addressCountry,
    entityType,
    transferDestination,
    firstName,
    lastName,
    dateOfBirth,
    businessName,
  } = selectedFiatBeneficiary || {}
  const { bankAddress, bankName, intermediaryBank, accountNumber, code } = fiat || {}

  const payRequest: WalletsPayRequest = {
    amount: Number(formValues?.amount),
    authorization: {
      ...(twoFactorEnabled && { totp: formValues.twoFactorCode }),
      ...(!twoFactorEnabled && { password: formValues.twoFactorCode }),
    },
    receiver: {
      ...(entityType && { type: entityType }),
      ...(addressCountry && { countryCode: addressCountry }),
      ...(formValues?.paymentReference && { reference: formValues?.paymentReference }),
      ...(transferDestination === BeneficiaryTransferDestination.INTERNATIONAL && {
        ...(address && { address }),
        ...(bankAddress && { bankAddress }),
        ...(intermediaryBank && { intermediaryBank }),
        ...(bankName && { bankName }),
      }),
      ...(accountNumber && { bankAccountNumber: accountNumber }),
      ...(code && { code }),
      ...(entityType === BeneficiaryEntityType.INDIVIDUAL && {
        firstName,
        lastName,
        dateOfBirth,
      }),
      ...(entityType === BeneficiaryEntityType.BUSINESS && {
        companyName: businessName,
      }),
    } as WalletPayReceiverDetails,
  }

  return payRequest
}
